var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuredocInitialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161729",
    "data-name": "Group 161729",
    transform: "translate(-325 -363.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140357",
    "data-name": "Rectangle 140357",
    width: 23,
    height: 23,
    rx: 4,
    transform: "translate(325 363.005)",
    fill: "#fbd5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "initials",
    d: "M3.69,2.75a.5.5,0,0,1,.467.32l3.21,8.32a.5.5,0,1,1-.933.36L5.383,9.025H2.011L.967,11.749a.5.5,0,1,1-.934-.358l3.19-8.32A.5.5,0,0,1,3.69,2.75Zm0,1.893L5.055,8.175H2.337Zm7.207.564a3.121,3.121,0,0,0-2.89,3.4,3.124,3.124,0,0,0,2.89,3.4,3.06,3.06,0,0,0,2.255-.99v.508a.45.45,0,0,0,.9,0V5.72a.45.45,0,0,0-.9,0v.5A3.01,3.01,0,0,0,10.9,5.207ZM13.154,9.8V7.3a2.425,2.425,0,0,0-2.068-1.244A2.3,2.3,0,0,0,9.035,8.61a2.3,2.3,0,0,0,2.052,2.552A2.544,2.544,0,0,0,13.154,9.8Z",
    transform: "translate(329.473 367.095)",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredocInitialsIcon);
export default __webpack_public_path__ + "static/media/securedoc-initials-icon.b98edcdb12d848121fffe8c677b3fec7.svg";
export { ForwardRef as ReactComponent };